import React, { useState, useEffect, useContext } from "react";

import tmdbApi from "../../api/tmdbApi";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import { useHistory, useParams } from "react-router-dom";
import { contentContext } from "../../context/contentContext";
import ReactHtmlParser from 'react-html-parser';
import $ from "jquery";
import Loader from "../../components/loader";
const ViewReports = () => {
  let { id } = useParams();
  const history = useHistory();
  const [quizResultData, setQuizResultData] = useState({});
  const [reportsData, setReportsData] = useState([]);
  const [imageCloudfront, setImg] = useState(false);
  const { isLoading, setIsLoading } = useContext(contentContext);
  useEffect(() => {
    if (!localStorage.getItem("token1")) {
      history.push("/login");
    }
  }, [])

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);

    // Fetch data from localStorage
    const quizResult = JSON.parse(localStorage.getItem("qr"));
    console.log("quizResult", quizResult);

    if (quizResult) {
      setQuizResultData(quizResult);
    }
  }, []);



  useEffect(() => {

    if (window.site === undefined) {
      setTimeout(() => {
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
          setImg(window.site.common.imageCloudfront)
        }
      }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imageCloudfront) {
      setImg(window.site.common.imageCloudfront)
    }


  }, [window.site]);

  useEffect(() => {

    GetReportsInfo();

  }, []);
  const handleBack = () => {
    history.goBack()
  }
  const GetReportsInfo = async () => {
    setIsLoading(true)
    try {
      const response = await tmdbApi.SingleReports(id);
      // console.log("response:", response);

      const mappedData = Object.entries(response?.result).map(([key, value], index) => ({
        id: index + 1,
        question: value.question,
        description: value.description,
        answers: value.answers,
        actualanswer: value.actualanswer,
        actualanswer: value.actualanswer,
        images: value.images
      }));
      console.log(mappedData);
      setReportsData(mappedData);
      setIsLoading(false);
    } catch {
      console.log("error");
    }
  };

  return (
    <main>
      <Header />
      <div className="wrapper quiz_page result">
        {isLoading ? <Loader /> :
          <>
            <div className="row mb-3 breadcrumb mt-3">
              <div className="col-lg-12">
                <div className="d-flex align-items-center">
                  <div className="title_block">
                    <h4 className="mb-2 card-title">Summary </h4>
                    <a class="border_btn" onClick={handleBack}>Back</a>
                  </div>
                </div>
              </div>
            </div>

            <div className="row table-data">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="reports_block user">
                      <div className="accordion" id="accordionExample">
                        <div className="accordion" id="accordionExample">
                          {reportsData?.map((item, index) => {
                            const actualAnswer = item?.actualanswer; // Extract actual answer
                            const answers = Object.entries(item?.answers || {});
                            const hasActualAnswer = Object.keys(item?.answers || {}).includes(actualAnswer);

                            // console.log('ittt',item)
                            return (
                              <div className="accordion-item" key={index}>
                                <h2 className="accordion-header" id={`heading${index}`}>
                                  <button
                                    className="accordion-button fw-medium"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapse${index}`}
                                    aria-expanded="true"
                                    aria-controls={`collapse${index}`}
                                  >
                                    {item?.question}
                                  </button>
                                </h2>
                                <div
                                  id={`collapse${index}`}
                                  className="accordion-collapse collapse show"
                                  aria-labelledby={`heading${index}`}
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="accordion-body">
                                    <div className="img_block">

                                      <div className="content">

                                        <p><span>   {ReactHtmlParser(item?.description?.slice(0, 370))}</span></p>
                                      </div>



                                      <div className="imgs">
                                        {item?.images?.length > 0 && item?.images?.map((item) => {
                                          return (
                                            <img src={`${imageCloudfront}${item?.filepath.replace(/ /g, "%20")}?auto=compress,format&width=80`}
                                              className="img" alt="" />
                                          )

                                        })}
                                      </div>

                                    </div>
                                    <div className="table_block">
                                      <table className="table report_table table-bordered align-middle nowrap">
                                        <thead>
                                          <tr>
                                            <th scope="col">No</th>
                                            <th scope="col">Answer</th>
                                            <th scope="col">Count</th>
                                            <th scope="col">Percentage</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {answers.map(([answer, { count, percentage }], idx) => {
                                            // Render the correct answer row with the "correct-answer" class
                                            const isCorrectAnswer = answer === actualAnswer; // Check if the answer is the correct answer

                                            return (
                                              <tr key={idx} className={isCorrectAnswer ? "correct-answer" : "wrong-answer"}>
                                                <td scope="row">{idx + 1}</td>
                                                <td>
                                                  {isCorrectAnswer ? (
                                                    <span className="correct">{answer}</span> // Apply "correct" class to the answer if it's correct
                                                  ) : (
                                                    <span >{answer}</span> // Render the answer normally if it's not the correct answer
                                                  )}
                                                </td>
                                                <td>{count}</td>
                                                <td>{percentage}</td>
                                              </tr>
                                            );
                                          })}



                                          {/* Add the "next row" only if there's no actual answer */}
                                          {!hasActualAnswer && (
                                            <tr key="next-row" className="correct-answer">
                                              <td >{answers.length + 1}</td>
                                              <td className="correct">
                                                {/* Add any custom content for the extra row */}
                                                {actualAnswer}
                                              </td>
                                              <td>0</td>
                                              <td>0%</td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}

                        </div>


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>

        }
      </div>


      <Footer />
    </main>
  );
};

export default ViewReports;
